import { OnInit } from '@angular/core';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { GLOBAL } from 'src/app/services/global';
var Formulario13Component = /** @class */ (function () {
    function Formulario13Component() {
        this.htmlcanvas = html2canvas;
        this.nombreMuni = GLOBAL.nombreMuni;
        this.region = GLOBAL.region;
        this.pages = [1, 2, 3];
    }
    Formulario13Component.prototype.ngOnInit = function () {
    };
    Formulario13Component.prototype.ngAfterContentChecked = function () {
        this.ngAfterContentInit();
    };
    Formulario13Component.prototype.ngAfterContentInit = function () {
        //INDEPENDIENTE
        if (JSON.parse(localStorage.getItem("independiente"))) {
            if (JSON.parse(localStorage.getItem("independiente")).length > 0) {
                this.independiente = JSON.parse(localStorage.getItem("independiente"));
            }
            else {
                localStorage.setItem("independiente", JSON.stringify([]));
                this.independiente = [{ rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', patente: '', registro: '', categoria: '', recordId: '' }];
            }
        }
        //TIPO SOLICITUD
        if (JSON.parse(localStorage.getItem("tipo_solicitud"))) {
            if (JSON.parse(localStorage.getItem("tipo_solicitud")).length > 0) {
                this.tipo_solicitud = JSON.parse(localStorage.getItem("tipo_solicitud"));
            }
            else {
                localStorage.setItem("tipo_solicitud", JSON.stringify([]));
                this.tipo_solicitud = [{ "optradio": { "AMPLIACIÓN MENOR A 100 M2": false, "MODIFICACIÓN": false, "ART 6 2 9 OGUC": false } }];
            }
        }
        //TIPO RECEPCION
        if (JSON.parse(localStorage.getItem("tipo_recepcion"))) {
            if (JSON.parse(localStorage.getItem("tipo_recepcion")).length > 0) {
                this.tipo_recepcion = JSON.parse(localStorage.getItem("tipo_recepcion"));
            }
            else {
                localStorage.setItem("tipo_recepcion", JSON.stringify([]));
                this.tipo_recepcion = [{ "option": '' }];
            }
        }
        //PROPIEDAD
        if (JSON.parse(localStorage.getItem("propiedad"))) {
            if (JSON.parse(localStorage.getItem("propiedad")).length > 0) {
                this.propiedad = JSON.parse(localStorage.getItem("propiedad"));
            }
            else {
                localStorage.setItem("propiedad", JSON.stringify([]));
                this.propiedad = [{ rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa: '', direc_complemento: '', direc_compl_num: '', loteo: '', manzana: '', plano: '', recordId: '' }];
            }
        }
        //PROPIETARIOS
        if (JSON.parse(localStorage.getItem("propietarios"))) {
            if (JSON.parse(localStorage.getItem("propietarios")).length > 0) {
                this.propietarios = JSON.parse(localStorage.getItem("propietarios"));
            }
            else {
                localStorage.setItem("propietarios", JSON.stringify([]));
                this.propietarios = [{ rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' }];
            }
        }
        //REPRESENTANTE
        if (JSON.parse(localStorage.getItem("representantes"))) {
            if (JSON.parse(localStorage.getItem("representantes")).length > 0) {
                this.representantes = JSON.parse(localStorage.getItem("representantes")); //no es obligatorio pero si tiene informacion debe estar permiso_notariado obligatoriamente
            }
            else {
                localStorage.setItem("representantes", JSON.stringify([]));
                this.representantes = [{ rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' }];
            }
        }
        //PERMISO NOTARIADO
        if (JSON.parse(localStorage.getItem("permiso_notariado"))) {
            if (JSON.parse(localStorage.getItem("permiso_notariado")).length > 0) {
                this.permiso_notariado = JSON.parse(localStorage.getItem("permiso_notariado"));
            }
            else {
                localStorage.setItem("permiso_notariado", JSON.stringify([]));
                this.permiso_notariado = [{ acreditacion: '', fecha: null, escritura: null, notario: '' }];
            }
        }
        //ARQUITECTOS
        if (JSON.parse(localStorage.getItem("arquitectos"))) {
            if (JSON.parse(localStorage.getItem("arquitectos")).length > 0) {
                this.arquitectos = JSON.parse(localStorage.getItem("arquitectos"));
            }
            else {
                localStorage.setItem("arquitectos", JSON.stringify([]));
                this.arquitectos = [{ rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', recordId: '' }];
            }
        }
        //EMPRESAS
        if (JSON.parse(localStorage.getItem("empresas"))) {
            if (JSON.parse(localStorage.getItem("empresas")).length > 0) {
                this.empresas = JSON.parse(localStorage.getItem("empresas"));
            }
            else {
                localStorage.setItem("empresas", JSON.stringify([]));
                this.empresas = [{ rut: '', nombre: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' }];
            }
        }
        //INFORME
        if (JSON.parse(localStorage.getItem("informe"))) {
            if (JSON.parse(localStorage.getItem("informe")).length > 0) {
                this.informe = JSON.parse(localStorage.getItem("informe"));
            }
            else {
                localStorage.setItem("informe", JSON.stringify([]));
                this.informe = [{ "infradio": 'NO', "num_informe": '', "fech_informe": '' }];
            }
        }
        //DATOS PROYECTO
        if (JSON.parse(localStorage.getItem("datos_proyecto"))) {
            if (JSON.parse(localStorage.getItem("datos_proyecto")).length > 0) {
                this.datos_proyecto = JSON.parse(localStorage.getItem("datos_proyecto"));
            }
            else {
                localStorage.setItem("datos_proyecto", JSON.stringify([]));
                this.datos_proyecto = [{ datos: '' }];
            }
        }
        //PERMISOS
        if (JSON.parse(localStorage.getItem("Permisos"))) {
            if (JSON.parse(localStorage.getItem("Permisos")).length > 0) {
                this.permisos = JSON.parse(localStorage.getItem("Permisos"));
            }
            else {
                localStorage.setItem("Permisos", JSON.stringify([]));
                this.permisos = [{ perm_numero: 0, perm_fecha: null, superfm2: 0, modproy: 'false', resolucion: 0, fecha_resol: null, perm_prim: 0, fecha_prim: null, recepcion: 0, fecha_recep: null, recordId: '' }];
            }
        }
        //CARACTERISTICAS PROYECTO
        if (JSON.parse(localStorage.getItem("caracteristica_proyecto"))) {
            if (JSON.parse(localStorage.getItem("caracteristica_proyecto")).length > 0) {
                this.caracteristica_proyecto = JSON.parse(localStorage.getItem("caracteristica_proyecto"));
            }
            else {
                localStorage.setItem("caracteristica_proyecto", JSON.stringify([]));
                this.caracteristica_proyecto = [{ destino: '', supertotal: '', modradio: '', usoradio: '' }];
            }
        }
        //RECEPCION
        if (JSON.parse(localStorage.getItem("recepcion"))) {
            if (JSON.parse(localStorage.getItem("recepcion")).length > 0) {
                this.recepcion = JSON.parse(localStorage.getItem("recepcion"));
            }
            else {
                localStorage.setItem("recepcion", JSON.stringify([]));
                this.recepcion = [{ superedif: '', destino_cont: '' }];
            }
        }
    };
    Formulario13Component.prototype.captureScreen = function () {
        var _this = this;
        var pdf = new jspdf('p', 'mm', 'a4');
        this.htmlcanvas(document.getElementById("page1")).then(function (canvas) {
            var contentDataURL = canvas.toDataURL('image/png');
            pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297);
        });
        this.htmlcanvas(document.getElementById("page2")).then(function (canvas) {
            var contentDataURL = canvas.toDataURL('image/png');
            pdf.addPage();
            pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297);
        });
        this.htmlcanvas(document.getElementById("page3")).then(function (canvas) {
            var contentDataURL = canvas.toDataURL('image/png');
            pdf.addPage();
            pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297);
        });
        setTimeout(function () {
            pdf.save(_this.propietarios[0].rut + '.pdf');
            // pdf.save('prueba.pdf')
        }, 6000);
    };
    return Formulario13Component;
}());
export { Formulario13Component };
